/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';

import { UserDataService } from 'app/shared/services/user-data.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private router: Router, public userDataService: UserDataService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // intercept api origin requests only
    if (request.url.startsWith(environment.apiHostname)) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.userDataService.getToken()}`.trim(),
        },
      });
    }

    return next.handle(request);
  }
}
